<template>
    <Button :active="checked" class="tw-flex tw-rounded-md">
        <div class="tw-p-1 tw-w-full tw-flex tw-items-center tw-gap-4 tw-text-left tw-leading-5">
            <i
                class="mdi tw-text-base"
                :class="{
                    'mdi-radiobox-blank': !checked,
                    'mdi-radiobox-marked': checked,
                }"
            ></i>
            <div>
                <slot></slot>
            </div>
        </div>
    </Button>
</template>
<script setup>
import Button from '@/js/components/controls/Button.vue';

defineProps({
    checked: {
        type: Boolean,
        default: false,
    },
});
</script>
